import React, { useEffect } from 'react';
const ArabicRegister = (props) => {

    // console.log(props?.registration_data,"registrationData");
    let headings = props?.registration_data?.enroll_title;
    let registration_table_rows = props?.registration_data?.enroll_detail.map((innerItem) => (
        <tr>
            <td>{innerItem?.enroll_type_d ?? null}</td>
            <td>{innerItem?.individual_d ?? null}</td>
            <td>{innerItem?.group_rate_d ?? null}</td>
        </tr>
    ))

    useEffect(() => {
		
        const script = document.createElement('script');
        script.setAttribute(
          'src', 
          'https://fs23.formsite.com/include/form/embedManager.js?1475286034');
        script.addEventListener('load', () => {
          EmbedManager.embed({
            key: "https://fs23.formsite.com/res/showFormEmbed?EParam=m_OmK8apOTD5ovQ3l4B2tYpEHaDzsK4NFzpUCZwnDno&1475286034",
            width: "100%",
            mobileResponsive: true
          });
        });
		document.getElementById('embed-form').appendChild(script);

    }, []);

    return ( 
        <div className='register-today' id='register' >
            <div className='register-heading' >Register Today </div>

            {/*<p>{props?.registration_data?.description_b ?? ''}</p>*/}
            <div dangerouslySetInnerHTML={{ __html: props?.registration_data?.description_b }}></div>
            {/*<p>The registration form below is meant for individuals selecting Community enrollment type. No academic credit is granted and no transcript is provided for completed courses. If you are interested in graduate-level academic credit that may be transferable to another school, please contact us at <b style={{textDecoration:'underline'}}><a href='mailto:admin@bayanclaremont.org'>admin@bayanclaremont.org</a></b> for assistance, as the enrollment procedure is different.</p>*/}
          <div className='register-table'>
            <table style={{minWidth:'504px'}} >
                <tr>
                    {Object.keys(headings).slice(1).map((heading, i) => (
                        <th>
                            {headings[heading] ?? ''}
                        </th>
                    ))}
                    {/*<th>Enrollment Type</th>*/}
                    {/*<th>Individual</th>*/}
                    {/*<th>Group Rate</th>*/}
                </tr>
                {registration_table_rows ?? ''}
                {/*<tr>*/}
                {/*    <td>Community / Non-Credit (no transcript)</td>*/}
                {/*    <td>$700</td>*/}
                {/*    <td>$500</td>*/}
                {/*</tr>*/}
                {/*<tr>*/}
                {/*    <td>Graduate Credit (transferable / transcript)</td>*/}
                {/*    <td>$2846</td>*/}
                {/*    <td>n/a</td>*/}
                {/*</tr>*/}
            </table>
            </div>
            {/*{props?.registration_data?.description_m}*/}
            <div dangerouslySetInnerHTML={{ __html: props?.registration_data?.description_m }}></div>
            {/*<p>Groups of five or more learners who register together are eligible for the group rate.</p>*/}
            {/*<h6>Registration Deadline: January 31.</h6>*/}


          
            
            <div id='embed-form'>
            <a name="form1475286034" id="formAnchor1475286034"></a>
            </div>


            {/*<p>{props?.registration_data?.description_a ??''}</p>*/}
            <div dangerouslySetInnerHTML={{ __html: props?.registration_data?.description_a }}></div>
            {/*<>*/}
            {/*    Refund Schedule:*/}
            {/*        <ul type='none'>*/}
            {/*            <li> Before Feb. 12: 100%</li>*/}
            {/*            <li> Between Feb. 13 - 26: 50%</li>*/}
            {/*            <li> After Feb. 26: no refund but payment can be applied to a future semester</li>*/}
            {/*        </ul>*/}
            {/*</>*/}
    </div>

     );
}

export default ArabicRegister; 